import {connect} from "react-redux";
import React, {useState} from "react";
import {trackGoal} from "../../methods/trackGoal";
import notifyUser from "../../methods/notifyUser";
import {isSMSAllowedForPhoneNumber, isCallAllowedForPhoneNumber, isReverseCallAllowedForPhoneNumber, isTGGatewayAllowedForPhoneNumber, isWhatsAppAllowedForPhoneNumber} from "../../funcs";
import {CircularProgress} from "@mui/material";

export function notifyUserAboutCode(props: any, channel: string) {
    if (channel == "sms") {
        notifyUser(props, 'Введите код из смс')
    }
    if (channel == "tg-gateway") {
        notifyUser(props, 'Код отправлен в Telegram')
    }
    if (channel == "tg") {
        notifyUser(props, 'Запрос кода через телеграм', 'Чтобы получить код - поделитесь с ботом своим номером телефона.')
    }
    if (channel == "max") {
        notifyUser(props, 'Запрос кода через MAX', 'Чтобы получить код — откройте MAX бота и поделитесь контактом через кнопку.')
    }
    if (channel == "call") {
        notifyUser(props, 'Запрос кода через звонок', 'Вам поступит звонок. Его можно отклонить. Вам нужно ввести 4 последние цифры телефона, с которого вам позвонили')
    }
    if (channel == "reverse-call") {
        notifyUser(props, 'Обратный звонок', 'Позвоните на указанный бесплатный номер с вашего телефона. После звонка код подставится автоматически.')
    }
    if (channel == "whatsapp") {
        notifyUser(props, 'Код отправлен в WhatsApp', 'Проверьте сообщение от OkiDoki в WhatsApp на указанный номер.')
    }
}

export let DidntReceiveCode: any = function EntityFormPopup(props: any) {
    const [isLoading, setIsLoading] = useState(false)
    
    async function handleGetCode(channel: string, fromChannel: string) {
        if (isLoading || props.isRequestingCode) return

        setIsLoading(true)
        try {
            trackGoal(`register_didnt_get_code_from_${fromChannel}`)
            await props.getCode(channel)
        } finally {
            setIsLoading(false)
        }
    }
    
    function makeButton(title: string, channel: string, fromChannel: string) {
        return <button
            className="new"
            style={{display: "block", width: "100%", textAlign: "left"}}
            disabled={isLoading || props.isRequestingCode}
            onClick={() => {
                handleGetCode(channel, fromChannel)
            }}
        >
            <div className="Body_15" style={{color: "#0070FF"}}>
                {title}
            </div>
        </button>
    }

    // Формируем список доступных альтернативных каналов
    const currentChannel = props.channel
    const disabled_channels = props.disabled_code_channels || []
    
    // Список всех доступных каналов с проверками
    const availableChannels = [
        {
            channel: "tg-gateway",
            title: "получите код через Telegram",
            available: isTGGatewayAllowedForPhoneNumber(props.phone_number, disabled_channels)
        },
        {
            channel: "max",
            title: "получите код через MAX",
            available: !disabled_channels.includes("max")
        },
        {
            channel: "call",
            title: "получите код по телефонному звонку",
            available: isCallAllowedForPhoneNumber(props.phone_number, disabled_channels)
        },
        {
            channel: "sms",
            title: "получите код через смс",
            available: isSMSAllowedForPhoneNumber(props.phone_number, disabled_channels, props.purpose)
        },
        {
            channel: "whatsapp",
            title: "получите код через WhatsApp",
            available: isWhatsAppAllowedForPhoneNumber(props.phone_number, disabled_channels)
        },
        {
            channel: "reverse-call",
            title: "звонок на бесплатный номер",
            available: props.reverse_flash_call_enabled === true
                && isReverseCallAllowedForPhoneNumber(props.phone_number, disabled_channels)
        }
    ]
    
    // Фильтруем доступные каналы, исключая текущий
    const alternativeChannels = availableChannels.filter(
        ch => ch.available && ch.channel !== currentChannel
    )

    // Если нет альтернатив, ничего не показываем
    if (alternativeChannels.length === 0) {
        return <></>
    }

    // Формируем сообщение в зависимости от текущего канала
    let message = ""
    if (currentChannel == "sms") {
        message = "Не приходит смска?"
    } else if (currentChannel == "tg-gateway") {
        message = "Не получили код в Telegram?"
    } else if (currentChannel == "call") {
        message = "Не поступает входящий звонок?"
    } else if (currentChannel == "reverse-call") {
        message = "Не удалось дозвониться на бесплатный номер?"
    } else if (currentChannel == "tg") {
        message = "Не понятно как получить код через телеграм?"
    } else if (currentChannel == "max") {
        message = "Не понятно как получить код через MAX?"
    } else if (currentChannel == "whatsapp") {
        message = "Не пришло сообщение в WhatsApp?"
    } else {
        message = "Не получили код?"
    }

    // Возвращаем список альтернатив
    return <div>
        <div className="Body_15" style={{textAlign: "left"}}>
            <div style={{marginBottom: 10}}>{message}</div>
            <div style={{display: "flex", flexDirection: "column", gap: 8, alignItems: "stretch"}}>
                {alternativeChannels.map((ch) => (
                    <div key={ch.channel}>
                        {makeButton(ch.title, ch.channel, currentChannel)}
                    </div>
                ))}
            </div>
        </div>
        {isLoading && (
            <div style={{marginTop: "10px", display: "flex", justifyContent: "center"}}>
                <CircularProgress size={16} sx={{color: "#0070FF"}} />
            </div>
        )}
    </div>
}

DidntReceiveCode = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(DidntReceiveCode)
